import type { LabeledIconsListTheme } from 'Src/types/reservation';
import { classnames } from 'Utils/classnames/classnames.utils';

const small = {
  thRoot: '',
  thHeaderElements: '',
  thHeader: 'md:py-10 w-full',
  thDates: 'hidden',
  thSlideshowBlock: 'isolate relative',
  thSlideshow: 'isolate overflow-hidden rounded-t-12',
  thTag: 'absolute m-10 end-0 top-0 z-1',
  thContent: 'pb-10',
  thInfos: 'my-10 -mx-5',
  thTitle: 'mb-5',
  thAvailability: 'my-5',
  thDesc: 'mb-10',
  thDistribution: 'mb-10',
  thArrangement: 'mb-10',
  thShared: 'mb-10',
  thSeemore: 'w-full',
  thSeemoreBtn: 'ms-auto text-end',
  thSeemoreContent: 'flex flex-wrap',
  thDetail: 'pb-10 w-full',
  thDetailTitle: 'mb-10',
  thDetailListTheme: 'listCondensed' as LabeledIconsListTheme,
};
export const themes = (isExclusiveCollectionSpace, isExclusiveCollectionRoom, isMobile) => {
  return {
    default: small,
    medium: small,
    large: {
      ...small,
      thRoot: 'sm:flex sm:flex-row sm:flex-wrap',
      thHeader: 'sm:hidden',
      thDates: classnames(small.thDates, 'mb-10 w-full md:block'),
      thSlideshowBlock: classnames(small.thSlideshowBlock, 'sm:pe-10', {
        'sm:w-1/2 md:w-2/5': !isExclusiveCollectionSpace && !isExclusiveCollectionRoom,
        'sm:w-1/2 md:w-3/5': isExclusiveCollectionSpace || isExclusiveCollectionRoom,
      }),
      thTag: classnames(small.thTag, 'sm:mx-20'),
      thContent: classnames(small.thContent, 'flex flex-col sm:pb-0 sm:ps-10', {
        'sm:w-1/2 sm:justify-between md:w-3/5':
          !isExclusiveCollectionSpace && !isExclusiveCollectionRoom,
        'sm:w-1/2 md:w-2/5': isExclusiveCollectionSpace || isExclusiveCollectionRoom,
      }),
      thHeaderElements: classnames('mb-5', { hidden: isMobile }),
      thInfos: classnames(small.thInfos, 'sm:order-last sm:mb-0'),
      thSeemoreContent: classnames(small.thSeemoreContent, 'sm:-mx-10'),
      thDetail: classnames(small.thDetail, 'sm:w-1/2 sm:p-10'),
      thDetailListTheme: 'listCondensed',
    },
  };
};
